import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const ModalComponent = React.lazy(() => import("../Components/RootComponents/ModalComponent"));
const ModalPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <ModalComponent />
      </Suspense>
    </Fragment>
  );
};

export default ModalPage;
